import {
  CLOSE_NOTIFICATION_BLOCKED_PROMPT,
  SHOW_NOTIFICATION_BLOCKED_PROMPT,
} from '../constants/actions';

const notificationBlockedPromptReducer = (state = false, action) => {
  switch (action.type) {
    case CLOSE_NOTIFICATION_BLOCKED_PROMPT:
      return false;
    case SHOW_NOTIFICATION_BLOCKED_PROMPT:
      return true;
    default:
      return state;
  }
};

export default notificationBlockedPromptReducer;
